<aside #sourcesPanel *ngIf="drawer.state().open" class="sources-panel fixed" role="dialog" aria-modal="true">
  <div class="resizer" (mousedown)="onStartResize($event)"></div>
  <div class="sp-drawer-backdrop" (click)="close()"></div>

  <div class="sp-drawer-panel" role="dialog" aria-modal="true">
  <button mat-icon-button class="icon-button-s close" data-fs-element="Open-Search-Panel-Drawer-Button-Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>

    <div class="sp-content-wrapper">
      <app-search-panel
        [searchType]="drawer.state().searchType"
        [showAll]="drawer.state().showAll ?? false"
        [items]="drawer.state().items"
        (itemsChange)="drawer.setItems($event ?? drawer.state().items)"
        [showAllResults]="drawer.state().showAllResults ?? false"
        (showAllResultsChange)="drawer.patch({ showAllResults: $event })"
        [showSearchPanel]="drawer.state().showSearchPanel"
        (showSearchPanelChange)="drawer.patch({ showSearchPanel: $event })"
        [isShowAllResults]="drawer.state().isShowAllResults ?? false"
        (isShowAllResultsChange)="drawer.patch({ isShowAllResults: $event })"
      ></app-search-panel>
    </div>
  </div>
</aside>
